import { getContentApiUrl } from '@/config/constants';
import type { ContentDto, ContentWrapperDto } from '@/types/content';

function normalizeExperience(item: unknown): ContentDto | null {
  if (!item || typeof item !== 'object') return null;
  const o = item as Record<string, unknown>;
  const idRaw = o.id;
  const id = typeof idRaw === 'number' ? idRaw : Number(idRaw);
  const name = typeof o.name === 'string' ? o.name : '';
  const slugVal = o.slug;
  const slug = typeof slugVal === 'string' ? slugVal.trim() : '';
  if (!Number.isFinite(id) || !slug) return null;
  return { id, name, slug };
}

export async function fetchContent(): Promise<ContentWrapperDto | null> {
  const url = getContentApiUrl();
  if (!url) return null;

  try {
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return null;
    const raw = (await res.json()) as Record<string, unknown>;
    if (!raw || typeof raw !== 'object') return null;
    const continentGroup = raw.continentGroup ?? raw.continent_group;
    const experiences = raw.experiences;
    const tourCountries = raw.tourCountries ?? raw.tour_countries;
    const rawExp = Array.isArray(experiences) ? experiences : [];
    return {
      continentGroup: Array.isArray(continentGroup) ? continentGroup : [],
      experiences: rawExp.map(normalizeExperience).filter((x): x is ContentDto => x !== null),
      tourCountries: Array.isArray(tourCountries) ? tourCountries : [],
    };
  } catch {
    return null;
  }
}
